import { Details } from "./types";

export type CardFieldData = {
  charSimp: string;
  charTrad: string;
  pinyin: string;
  meaning: string;
};

const hasContent = (value: unknown): value is string =>
  typeof value === "string" && value.trim().length > 0;

export const getVisibleCharText = (
  cardDetails: CardFieldData,
  side: "front" | "back",
  detailsOptions: Details
): string => {
  const opts = detailsOptions[side];
  const showSimp = opts.charSimp && hasContent(cardDetails.charSimp);
  const showTrad = opts.charTrad && hasContent(cardDetails.charTrad);

  if (showSimp && showTrad && cardDetails.charSimp !== cardDetails.charTrad) {
    return `${cardDetails.charSimp} ${cardDetails.charTrad}`;
  }
  if (showSimp) {
    return cardDetails.charSimp;
  }
  if (showTrad) {
    return cardDetails.charTrad;
  }
  return "";
};

export const getVisibleDetailLines = (
  cardDetails: CardFieldData,
  side: "front" | "back",
  detailsOptions: Details
): { key: string; value: string; kind: "pinyin" | "meaning" }[] => {
  const opts = detailsOptions[side];
  const lines: { key: string; value: string; kind: "pinyin" | "meaning" }[] = [];

  if (opts.pinyin && hasContent(cardDetails.pinyin)) {
    lines.push({ key: "pinyin", value: cardDetails.pinyin, kind: "pinyin" });
  }
  if (opts.meaning && hasContent(cardDetails.meaning)) {
    lines.push({ key: "meaning", value: cardDetails.meaning, kind: "meaning" });
  }

  return lines;
};
